//******************************Consultas API************************************************** */
import { getCAIProveedor, getProveedorCAIporVendor } from "../../../../API/Compras/Proveedores/ProveedoresCAIRequest"
import { getCompanyCustomer } from "../../../../API/Compras/Proveedores/ProveedoresRequest"

export const verificarCAI = async (informacion) => {
    let IdProveedorCAI = informacion.IdProveedorCAI
    let factura = informacion.Factura
    let fechaFactura = new Date(informacion.FechaFactura)

    const result = await getCAIProveedor(IdProveedorCAI)
    let datosCAI = result[0]

    let mensaje = ''
    let valido = false

    if (fechaFactura > new Date(datosCAI?.FechaVencimiento)) {
        mensaje = 'La fecha de la factura supero la fecha de vencimiento del CAI seleccionado'
    } else {
        let RI = (datosCAI?.RangoInicial)?.toString()
        let RF = (datosCAI?.RangoFinal)?.toString()
        let ND = factura?.substring((factura)?.length - 8)
        let prefijoCAI = datosCAI?.Prefijo?.substring(0, 11)

        let prefijo = factura?.slice(0, -8)

        let RIF = RI, RFF = RF
        if (RI?.length < 8) {
            RIF = RI.padStart(8, 0)

        }

        if (RF?.length < 8) {
            RFF = RF.padStart(8, 0)
        }

        if (parseInt(ND) <= parseInt(RFF) && parseInt(ND) >= parseInt(RIF)) {
            if (prefijo === prefijoCAI) {
                if (fechaFactura <= new Date(datosCAI.FechaVencimiento)) {
                    valido = true
                }
            } else {
                mensaje = 'EL numero de factura no se encuentra dentro de lo valores del CAI del proveedor'
            }
        } else {
            valido = false
            mensaje = 'EL numero de factura no se encuentra dentro de lo valores del CAI del proveedor'
        }

    }

    return { valido: valido, msj: mensaje }

}

export const ValidarFacturaProveedor = async (informacion) => {
    let IdProveedor = informacion?.CustomerName?.IdVendor || informacion?.IdVendor
    let factura = informacion.Factura
    let IdProveedorCAI = informacion?.IdProveedorCAI
    let fechaFactura = new Date(informacion.FechaFactura)

    let valido = true
    let mensaje = ''
    let valores = { IdProveedorCAI: null }

    const tempoProv = await getCompanyCustomer(IdProveedor)

    if (tempoProv?.length > 0) {
        if (tempoProv[0]?.IdCountry === 95) {
            if (!IdProveedorCAI) {
                const temp = await getProveedorCAIporVendor(IdProveedor)
                if (temp?.length > 0) {

                    let b = temp.find((c) => {
                        let RI = (c.RangoInicial)?.toString()
                        let RF = (c.RangoFinal)?.toString()
                        let ND = factura.substring((factura)?.length - 8)
                        let prefijo = factura.slice(0, -8)
                        let prefijoCAI = c.Prefijo?.substring(0, 11)

                        let RIF = RI, RFF = RF
                        if (RI?.length < 8) {
                            RIF = RI.padStart(8, 0)

                        }

                        if (RF?.length < 8) {
                            RFF = RF.padStart(8, 0)
                        }
                       
                        if (parseInt(ND) <= parseInt(RFF) && parseInt(ND) >= parseInt(RIF)) {
                            if (prefijo === prefijoCAI) {
                                if (fechaFactura <= new Date(c.FechaVencimiento)) {
                                    
                                    return c
                                }else{
                                    valido = false
                                    mensaje = 'La fecha de la factura supero la fecha de vencimiento del CAI seleccionado'
                                    return { Valido: valido, Valores: valores, Mensaje: mensaje }
                                }
                            }
                        }

                    });

                    // console.log(b)
                    if (b) {
                        valores = { IdProveedorCAI: b?.IdProveedorCAI, Factura: factura, FechaFactura: fechaFactura, NombreSucursal: b?.NombreSucursal }
                    } else {
                        valido = false
                        mensaje = 'No se ha encontrado algún CAI del proveedor '
                    }
                } else {
                    valido = false
                    mensaje = 'No se ha encontrado algún CAI del proveedor. Revise Factura y Fecha Factura'
                }
            }
        }
    }

    return { Valido: valido, Valores: valores, Mensaje: mensaje }
}


